// extracted by mini-css-extract-plugin
export default {"container":"MyJas","title":"Y4u1z"};